import { useMemo } from "react";
import {
  SearchableSelect,
  type SearchableSelectOption,
} from "@/components/ui/searchable-select";

export type PatientPickOption = {
  id: string;
  name: string;
  phone?: string | null;
  uhid?: string | null;
  patientUniqueId?: string | null;
};

export function patientsToSearchableOptions(
  patients: PatientPickOption[]
): SearchableSelectOption[] {
  return patients.map((patient) => {
    const idLabel = patient.uhid ?? patient.patientUniqueId ?? "";
    const phone = patient.phone ?? "";
    return {
      value: patient.id,
      label: `${patient.name}${idLabel ? ` · ${idLabel}` : ""}${phone ? ` · ${phone}` : ""}`,
      searchText: [patient.name, idLabel, patient.patientUniqueId, phone]
        .filter(Boolean)
        .join(" "),
    };
  });
}

type PatientSearchableSelectProps = {
  patients: PatientPickOption[];
  value: string;
  onValueChange: (patientId: string) => void;
  disabled?: boolean;
  placeholder?: string;
  id?: string;
  className?: string;
};

export function PatientSearchableSelect({
  patients,
  value,
  onValueChange,
  disabled,
  placeholder = "Search and select patient…",
  id,
  className,
}: PatientSearchableSelectProps) {
  const options = useMemo(() => patientsToSearchableOptions(patients), [patients]);

  return (
    <SearchableSelect
      id={id}
      value={value}
      onValueChange={onValueChange}
      options={options}
      placeholder={placeholder}
      searchPlaceholder="Type patient name, UHID, or phone…"
      disabled={disabled}
      emptyMessage="No patients match your search."
      className={className}
      contentClassName="z-[100]"
    />
  );
}
